import area from './area'
import page from './page'
import layout from './layout'
import faq from './faq'
import theme from './theme'
import landing from './landing'
import splash from './splash'

export default {
  name: 'SiteCms',
  path: 'cms',
  meta: {
    label: 'content',
    auth: 'cms'
  },
  component: {
    name: 'Cms',
    render(c) {
      return c('router-view')
    }
  },
  children: [area, page, layout, faq, theme, landing, splash]
}
